import Reveal from './Reveal';
import SectionHeading from './SectionHeading';

const team = [
  { name: 'Rohan Kapoor', role: 'Senior Hair Stylist', image: 'photo-1503951914875-452162b0f3f1', bio: 'Thoughtful cuts and colour with an eye for the little details.' },
  { name: 'Meera Khan', role: 'Beauty Expert', image: 'photo-1580618672591-eb180b1a973f', bio: 'A calm, considered approach to skin and everyday beauty.' },
  { name: 'Kavya Malhotra', role: 'Bridal Makeup Artist', image: 'photo-1487412947147-5cebf100ffc2', bio: 'Soft, personal bridal looks for your most meaningful days.' },
  { name: 'Arjun Singh', role: "Men's Grooming Specialist", image: 'photo-1506794778202-cad84cf45f1d', bio: 'Modern grooming and sharp styles that feel like you.' }
];

function Team() {
  return (
    <section className="section team-section" id="team">
      <div className="container">
        <Reveal><SectionHeading eyebrow="Good people, good hands" title="Meet your new favourite people." description="Friendly faces, skilled hands and a genuine love for helping people feel their best." centered /></Reveal>
        <div className="team-grid">
          {team.map((person, index) => <Reveal className="team-card" key={person.name} delay={index * 0.06}>
            <div className="team-image"><img src={`https://images.unsplash.com/${person.image}?auto=format&fit=crop&w=640&q=82`} alt={person.name} /></div>
            <span className="team-role">{person.role}</span><h3>{person.name}</h3><p>{person.bio}</p>
          </Reveal>)}
        </div>
      </div>
    </section>
  );
}

export default Team;
